<template>
  <Appendix
    title="Phụ lục Link Card"
    :fields="fieldsTable"
    :actions="actions"
    :excepts="excepts"
    :only="only"
    :items="items"
    :contract="contract"
  >
    <template #row-details="item">
      <div>Mức phí: {{ item.appendixLinkCard.fee }}</div>
      <div v-if="item.signType">
        Hình thức ký:
        {{
          item.signType === 'SIGN_ECONTRACT'
            ? 'Ký điện tử'
            : item.signType === 'SIGN_PCONTRACT'
              ? 'Ký giấy'
              : ''
        }}
      </div>
    </template>
    <template #file="item">
      <div v-if="item.urlPDF" class="form-detail">
        <UploadMultiple
          :lsData="[item]"
          keyUrl="urlPDF"
          :canUpload="false"
          :title="`File phụ lục ${item.code}`"
          titleTag="h1"
          titleClass="form-inner-heading"
        />
      </div>
    </template>
  </Appendix>
</template>
<script>
  import Appendix from './Appendix.vue'
  import UploadMultiple from '@/components/UploadMultiple.vue'
  export default {
    props: {
      actions: {
        type: Function,
      },
      excepts: {
        type: Array,
        default: () => [],
      },
      only: {
        type: Array,
        default: () => [],
      },
      items: {
        type: Array,
        default: () => [],
      },
      contract: {
        type: Object,
        default: () => {},
      },
    },
    components: { Appendix, UploadMultiple },
    data() {
      return {
        fieldsTable: [
          { key: 'code', label: 'Số phụ lục', class: 'text-left' },
          {
            key: 'time',
            label: 'Thời gian',
            class: 'text-left',
            thStyle: 'min-width: 210px',
          },
          { key: 'state', label: 'Trạng thái', class: 'text-center' },
          { key: 'action', label: 'Thao tác', class: 'text-center' },
        ],
      }
    },
  }
</script>

<style scoped></style>
